import "../../assets/css/marketplace.css"
// import './styles/newstyles.css';
import "./styles/landing.css"

import nftFirst from "./images/First-nft.png"
import nftSecond from "./images/second-nft.png"
import nftThird from "./images/third-nft.png"
import SideIcon from "./sideIcon"

function LandingPageNew() {
  return (
    <div>
      <div className="landing-page">
        <div className="landing-main">
          <h1>Marketplace</h1>
        </div>

        <div className="nft-section-landing">
          <div className="container">
            <div className="row">
              <div className="nft-card-landing col-md-4">
                <div className="nft-image-landing">
                  <img src={nftFirst} alt="Nft" />
                </div>

                <h5>
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Maiores placeat explicabo natus ipsam quasi id consectetur
                  eligendi iure deserunt odit? Do
                </h5>
              </div>
              <div className="nft-card-landing col-md-4">
                <div className="nft-image-landing">
                  <img src={nftSecond} alt="Nft" />
                </div>

                <h5>
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Maiores placeat explicabo natus ipsam quasi id consectetur
                  eligendi iure deserunt odit? Do
                </h5>
              </div>
              <div className="nft-card-landing col-md-4">
                <div className="nft-image-landing">
                  <img src={nftThird} alt="Nft" />
                </div>

                <h5>
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Maiores placeat explicabo natus ipsam quasi id consectetur
                  eligendi iure deserunt odit? Do
                </h5>
              </div>
            </div>
          </div>
        </div>

        <div className="third-section-landing">
          <div className="container">
            <h1>OPEN PACKS TO FIND EXCITING NFTS</h1>

            <div className="row">
              <div className="dropboxes">
                <img
                  src="https://img.icons8.com/ios/50/ffffff/when-quest.png"
                  alt="what"
                />
                <h3>When do new drops happen?</h3>
                <p>
                  In the beta phase, pack drop times will vary, so make sure you
                  watch out for announcements
                </p>
              </div>
              <div className="dropboxes">
                <img
                  src="https://img.icons8.com/ios/50/ffffff/how-many-quest--v2.png"
                  alt="when"
                />
                <h3>How do I learn about upcoming drops?</h3>
                <p>
                  Sign up via email, drop into our Discord, or follow us on
                  social to never miss out an announcement
                </p>
              </div>
              <div className="dropboxes">
                <img
                  src="https://img.icons8.com/ios/50/ffffff/where-what-quest.png"
                  alt="what"
                />
                <h3>What if i dont get a pack in A drop?</h3>
                <p>
                  We will drop more packs in the days ahead. you can also buy
                  NFTs on the marketplace
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SideIcon />
    </div>
  )
}

export default LandingPageNew
